export default __webpack_public_path__ + "static/media/4.Sand-filter.e65ecdb9.jpg";